<template lang="pug">
    section(class="lg:container px-4 py-4")
        div(class="space-y-4 md:flex md:flex-row-reverse md:justify-between md:items-start md:gap-4 md:space-y-0 lg:items-center")
            div(class="grid gap-4 auto-cols-auto grid-cols-2 items-end md:flex md:justify-end md:items-center md:flex-none")
                div
                    BaseButton(
                        color="BLACK"
                        class="text-primary w-full md:w-auto"
                        hasCustomTextColor
                        @click.native="openFacetMenu"
                    ) Filters

                div(class="flex-1 md:flex md:items-center md:flex-none")
                    label(class="font-bold mr-1") Sort By:
                    SortBy

            div(class="flex items-center")
                RefinementSelections

        Refinements
</template>

<script>
import BaseButton from '@/components/baseButton'
import SortBy from '@/components/search/sortBy'
import Refinements from './refinements'
import RefinementSelections from './refinementSelections'

export default {
    name: 'BuildsToolbar',
    components: {
        BaseButton,
        Refinements,
        RefinementSelections,
        SortBy,
    },
    methods: {
        openFacetMenu() {
            this.$overlay.show('buildsMenu')
        },
    },
}
</script>
